import type { ReceiptTemplate } from '../schema';

export const yvesSaintLaurentTemplate: ReceiptTemplate = {
  id: 'yves-saint-laurent',
  name: 'Yves Saint Laurent Receipt',
  brand: 'SAINT LAURENT',
  description: 'Saint Laurent luxury fashion receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ysl-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/yves-saint-laurent.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '3 EAST 57TH STREET',
          'NEW YORK, NY 10022',
          '(212) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ysl-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans #:', value: '28451' },
          { id: 'assoc', label: 'Associate:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '16:15' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ysl-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'KATE CHAIN BAG BLK', quantity: '1', price: '2450.00', sku: 'YSL847291' },
          { id: '2', name: 'TRIBUTE SANDALS', quantity: '1', price: '995.00', sku: 'YSL847292' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ysl-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '3445.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '305.74', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '3750.74', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ysl-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'AMEX ****7829',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ysl-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'RETURNS WITHIN 14 DAYS\nORIGINAL RECEIPT REQUIRED\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

